import {ActionButtonConfig} from '../../entity/action-button-config'
import {BaseMixins} from '../component/base-mixins'
import {Component} from '../component/decorator';
@Component
export class PageResultBaseMixins extends BaseMixins {

    /**
     * 新增按钮
     */
    addBtn() {
        return { add: { labelKey: "Action.Add", type: "primary", icon: "ios-add", permission: `${this.$route.meta.access[0]}.Add` } }
    }

    /**
     * 页面刷新
     */
    refresh(){
        (this.$refs["searchQuery"] as any).refresh();
    }

    /**
     * 删除
     * @param row
     * @param type
     */
    async delete(row:any, type?:string){
        await this.$store.dispatch({type: type, data: row});
        this.$Message.success(this.L("Tip.DeletedSuccessfully"));
        this.refresh();
    }

    /**
     * 删除按钮 permission默认页面权限 + .Delete
     * @param check 业务逻辑验证
     * @param type dispatchType 默认 module/menu/delete(路由name)
     */
    colDeleteBtn(check?:Function,type?:string){
        let dispatchType = type || this.getDispatchTypePrefix()  + "/delete";
        return {
            label: "Action.Delete",
            permission: this.$route.meta.access[0] + ".Delete",
            callback: this.delete,
            check:check,
            needPoptip: true,
            popTipContent: this.L("Tip.DeleteConfirm"),
            type:  dispatchType
        }
    }

    /**
     * 获取默认dispatch前缀
     */
    getDispatchTypePrefix(){
        let length = this.$route.matched.length;
        let commitType = this.$route.matched[length-2].name + "/" + this.$route.matched[length-1].name;
        if(this.$route.meta.hideInMenu){
            commitType = this.$route.matched[length-3].name + "/" + this.$route.matched[length-2].name;
        }
        return commitType;
    }

}